import { InjectionToken } from '@angular/core';
import { LocalizationData } from './projects/osn-shared/src/core/i18n/localization-data';

export const LOCALIZATION_DATA_TOKEN = new InjectionToken<() => LocalizationData>('localizationDataToken');
